<template>
  <div>
    <div
      v-if="group.name"
      class="card"
    >
      <h3>Group Name</h3>
      <b-row>
        <b-col md="6">
          English Name
        </b-col>
        <b-col md="6">
          Arabic Name
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6">
          {{ group.name.en }}
        </b-col>
        <b-col md="6">
          {{ group.name.ar }}
        </b-col>
      </b-row>
    </div>
    <div
      v-if="group.rules"
      class="card"
    >
      <h3>Group Rules</h3>
      <b-row>
        <b-col
          md="4"
        >
          Required
        </b-col>
        <b-col
          md="4"
        >
          Maximum allowed selections
        </b-col>
        <b-col
          md="4"
        >
          Minimum allowed selections
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col
          md="4"
        >
          {{ group.rules.required ? 'Yes' : 'No' }}
        </b-col>
        <b-col
          md="4"
        >
          {{ group.rules.maximumAllowedSelection }}
        </b-col>
        <b-col
          md="4"
        >
          {{ group.rules.minimumNumberOfSelections }}
        </b-col>
      </b-row>
    </div>
    <div
      v-if="group.selections"
      class="card"
    >
      <h3>Group Selections</h3>
      <div
        v-for="(selection, index) in group.selections"
        :key="selection.name.en + index"
        class="mx-2 mb-1 d-flex justify-content-between align-items-center"
      >
        <h6>{{ selection.name.en }} / {{ selection.name.ar }}</h6>
        <span>JOD {{ selection.price }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  components: { BRow, BCol },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
}
</script>

  <style scoped>
  .card {
    padding: 12px;
    border: 1px solid #4B6C95;
  }
  </style>
